import { loadingReducer } from '../loading/reducer';
import { FETCH_CREDITS_REQUEST, FETCH_CREDITS_SUCCESS, FETCH_CREDITS_FAILURE } from './actions';
const INITIAL_STATE = {
    data: {},
    loading: [],
    error: null
};
export function creditsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_CREDITS_REQUEST: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action)
            };
        }
        case FETCH_CREDITS_SUCCESS: {
            const { address, credits } = action.payload;
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                data: {
                    ...state.data,
                    [address]: credits
                },
                error: null
            };
        }
        case FETCH_CREDITS_FAILURE: {
            const { error } = action.payload;
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error
            };
        }
        default:
            return state;
    }
}
//# sourceMappingURL=reducer.js.map